import { FC, useState } from "react";
import { useTranslation } from "react-i18next";
import "./PropertyBoundaryPanel.css";
import { BoundaryPoint } from "../../types";

export interface PropertyBoundaryPanelProps {
  onBoundaryModeToggle: (operation: string) => void;
  boundaryPoints: BoundaryPoint[];
  isBoundaryMode: boolean;
}

export const PropertyBoundaryPanel: FC<PropertyBoundaryPanelProps> = ({
  onBoundaryModeToggle,
  boundaryPoints,
  isBoundaryMode,
}) => {
  const { t } = useTranslation();
  const [changeWarning, setChangeWarning] = useState<string>("");

  const handleCancelWarning = () => {
    setChangeWarning("");
  };

  const handleConfirmWarning = () => {
    if (changeWarning === "clear") {
      onBoundaryModeToggle("clear"); // TODO: CLEAR BOUNDARY
    } else if (changeWarning === "cancel") {
      onBoundaryModeToggle("cancel");
    } else if (changeWarning === "save") {
      onBoundaryModeToggle("save");
    }
    setChangeWarning("");
  };

  return (
    <div className="property-boundary-panel">
      <div className="panel-header">
        <h2>{t("admin.propertyBoundaries")}</h2>
      </div>

      <div className="property-view">
        <div className="property-instructions">
          <h3>{t("admin.setPropertyBoundaries")}</h3>
          <p>
            {t("admin.boundaryInstructions")}
          </p>
          {isBoundaryMode && (
            <div className="boundary-mode-active">
              <span className="mode-indicator">{t("admin.boundaryModeActive")}</span>
            </div>
          )}
        </div>

        <div className="boundary-actions">
          {isBoundaryMode ? (
            <>
              <button
                className="clear-boundary-btn"
                onClick={() => {
                  setChangeWarning("clear");
                }}
              >
                {t("admin.clearBoundary")}
              </button>
              <button
                className={`clear-boundary-btn ${
                  isBoundaryMode ? "active" : ""
                }`}
                onClick={() => {
                  setChangeWarning("cancel");
                }}
              >
                {t("admin.cancelChanges")}
              </button>
              <button
                className={`toggle-boundary-btn ${
                  isBoundaryMode ? "active" : ""
                }`}
                onClick={() => {
                  setChangeWarning("save");
                }}
              >
                {t("admin.saveBoundary")}
              </button>
            </>
          ) : (
            <button
              className={`toggle-boundary-btn ${
                isBoundaryMode ? "active" : ""
              }`}
              onClick={() => onBoundaryModeToggle("start")}
            >
              {t("admin.startEditingBoundary")}
            </button>
          )}
        </div>
      </div>
      {changeWarning.length > 0 && (
        <div className="change-warning-overlay">
          <div className="change-warning-modal">
            <div className="warning-header">
              <div className="warning-icon">⚠️</div>
              <h3>
                {changeWarning === "clear"
                  ? t("admin.clearBoundary")
                  : changeWarning === "cancel"
                  ? t("admin.cancelBoundary")
                  : changeWarning === "save"
                  ? t("admin.saveBoundary")
                  : ""}
              </h3>
            </div>
            <div className="warning-content">
              <p>
                {changeWarning === "clear" ? (
                  t("admin.clearBoundaryWarning")
                ) : changeWarning === "cancel" ? (
                  t("admin.cancelBoundaryWarning")
                ) : changeWarning === "save" ? (
                  <>
                    {t("admin.saveBoundaryWarning")}
                    <br />
                    {t("admin.dontForgetToSaveProject")}
                  </>
                ) : (
                  ""
                )}
              </p>
            </div>
            <div className="boundary-warning-actions">
              <button
                className="warning-cancel-btn"
                onClick={handleCancelWarning}
              >
                {changeWarning === "clear" || changeWarning === "save"
                  ? "Cancel"
                  : changeWarning === "cancel"
                  ? "Keep Editing"
                  : ""}
              </button>
              <button
                className={`warning-confirm-btn${
                  changeWarning === "save" ? " boundary-save-button" : ""
                }`}
                onClick={handleConfirmWarning}
              >
                {changeWarning === "clear"
                  ? t("admin.clear")
                  : changeWarning === "cancel"
                  ? t("admin.discardChanges")
                  : changeWarning === "save"
                  ? t("common.save")
                  : ""}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* {changeWarning === "clear" ? (
        <></>
      ) : changeWarning === "cancel" ? (
        <></>
      ) : changeWarning === "save" ? (
        <></>
      ) : (
        <></>
      )} */}
    </div>
  );
};
